import React, { useEffect, useMemo, useState } from 'react';
import FisEventIcon from "../../../images/FisEventIcon.png";
import HttpClient from '../../../utils/HttpClient';
import { useUserData } from '../../../Providers/UserWrapper';
import moment from 'moment';
import toast from 'react-hot-toast';
import { useLanguage } from '../../../Providers/LanguageContext';
import Select from 'react-select';
import './DeleteModal.css';

const EventSidebar = ({
  getEventData,
  setModalb,
  setTaskDetailData,
  eventAllData,
  selectAssignUserMemo,
  selectCustVendorMemo
}) => {
  const { isMainUserMemo, profileData } = useUserData();
  const { language } = useLanguage();
  const [eventId, setEventId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const initSelectData = { value: "", label: "" }
  const initEvent = {
    date: '',
    startTime: '',
    endTime: '',
    eventName: '',
    eventNotes: '',
    assignedUser: initSelectData,
    linkedUser: initSelectData,
    mtgLinkAddress: '',
    firstName: '',
    lastName: '',
    eventStatus: '',
    projectId: '',
  };
  const [formData, setFormData] = useState(initEvent);
  const [searchedData, setSearchedData] = useState(initSelectData);
  const [assignProjectData, setAssignProjectData] = useState([]);

  // Add these state variables for delete confirmation
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  // Delete confirmation handler
  const handleDeleteClick = (event) => {
    setProjectToDelete(event);
    setDeleteModalOpen(true);
    setDeleteConfirmText('');
  };

  // Confirm delete action
  const confirmDelete = async () => {
    if (deleteConfirmText.toLowerCase() !== 'delete') {
      toast.error('Please type "delete" to confirm');
      return;
    }

    setDeleting(true);
    try {
      await handleDeleteByEventId(projectToDelete._id);
      setDeleteModalOpen(false);
      setProjectToDelete(null);
      setDeleteConfirmText('');
    } catch (error) {
      toast.error('Failed to delete task');
    } finally {
      setDeleting(false);
    }
  };


  // getting assigned projects
  const getAssignedProject = async () => {
    const res = await HttpClient.requestData("view-all-project", "GET")
    if (res && res?.status) {
      setAssignProjectData(res?.data);
    }
  }

  useEffect(() => {
    getAssignedProject();
  }, []);

  const searchSelectOptionMemo = useMemo(() => {
    return eventAllData?.map((item) => ({
      value: item,
      label: item?.eventName
    }))
  }, [eventAllData])

  // Helper function to format assignToUser for Select component
  const formatAssignToUser = (userId) => {
    if (!userId) return initSelectData;

    const user = selectAssignUserMemo?.find(item => item.value === userId);
    return user || { value: userId, label: `User ${userId}` };
  };

  // Helper function to format linkedUser for Select component
  const formatLinkedUser = (userId) => {
    if (!userId) return initSelectData;

    const user = selectCustVendorMemo?.find(item => item.value === userId);
    return user || { value: userId, label: `User ${userId}` };
  };

  // Helper function to format date for input[type="date"]
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    return moment(dateString).format('YYYY-MM-DD');
  };

  //on change 
  const handleEventChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  // validate
  const validate = () => {
    if (!formData.date) {
      toast.error("Date is Required");
      return true
    }
    if (!formData.startTime) {
      toast.error("Start Time is Required");
      return true
    }
    if (!formData.endTime) {
      toast.error("End Time is Required");
      return true
    }
    if (!formData.eventName) {
      toast.error("Event Name is Required");
      return true
    }
    return false;
  }

  //submit click on schedule
  const handleSchrdule = async () => {
    if (validate()) {
      return
    }

    const data = {
      eventName: formData.eventName,
      eventNotes: formData.eventNotes,
      eventStatus: formData.eventStatus ? formData.eventStatus : 'open',
      assignToUser: isMainUserMemo ? formData.assignedUser?.value : profileData?._id,
      firstName: formData.firstName,
      lastName: formData.lastName,
      linkedUser: formData.linkedUser?.value,
      mtgLinkAddress: formData.mtgLinkAddress,
      selectDate: moment(formData.date).format('YYYY-MM-DD'),
      startTime: formData.startTime,
      endTime: formData.endTime,
      projectId: formData.projectId || '',
    };

    const res = await HttpClient.requestData("add-event-eventDetails", "POST", data);
    if (res && res?.status) {
      toast.success("Event Added Successfully");
      getEventData();
      setFormData(initEvent);
    } else {
      toast.error(res?.message || "Something Went Wrong");
    }
  };



  //update click on schedule
  const handleUpdate = async () => {
    if (validate()) {
      return
    }

    const data = {
      eventName: formData.eventName,
      eventNotes: formData.eventNotes,
      eventStatus: formData.eventStatus ? formData.eventStatus : 'open',
      assignToUser: isMainUserMemo ? formData.assignedUser?.value : profileData?._id,
      firstName: formData.firstName,
      lastName: formData.lastName,
      linkedUser: formData.linkedUser?.value,
      mtgLinkAddress: formData.mtgLinkAddress,
      selectDate: moment(formData.date).format('YYYY-MM-DD'),
      startTime: formData.startTime,
      endTime: formData.endTime,
      projectId: formData.projectId || '',
    };

    const res = await HttpClient.requestData(`update-event-eventDetails/${eventId}`, "PUT", data);
    if (res && res?.status) {
      toast.success(res?.message || "Event Updated Successfully");
      getEventData();
      setFormData(initEvent);
    } else {
      toast.error(res?.message || "Something Went Wrong");
    }
  };

  const handleDeleteByEventId = async id => {
    try {
      const res = await HttpClient.requestData(`delete-event-eventDetails/${id}`, "DELETE");
      if (res && res?.status) {
        toast.success(res?.message || "Event Deleted Successfully");
        getEventData();
      } else {
        toast.error(res?.message || "Something Went Wrong");
      }
    } catch (error) {
      toast.error(error?.message || 'something went wrong!!!');
    }
  }

  return (
    <div>
      {/* form */}
      <form action="" className="taskEvForm">
        <div>
          <div className="taskMainInpDiv">
            {/* search */}
            <div className="taskTabInps">
              <Select
                className="taskUpperInpSearch"
                placeholder={language.search}
                isClearable={true}
                isSearchable={true}
                value={searchedData?.value === "" ? null : searchedData}
                options={searchSelectOptionMemo}
                onChange={e => {
                  if (e) {
                    setSearchedData({ value: e.value, label: e.value?.eventName });
                    setTaskDetailData(e.value);

                    // Format assignToUser for the Select component
                    const formattedAssignToUser = formatAssignToUser(e.value?.assignToUser);

                    // Format linkedUser for the Select component
                    const formattedLinkedUser = formatLinkedUser(e.value?.linkedUser);

                    // Format dates for date inputs
                    const formattedStartDate = formatDateForInput(e.value?.selectDate);

                    setFormData({
                      date: formattedStartDate,
                      startTime: e?.value?.startTime || '',
                      endTime: e?.value?.endTime || '',
                      eventName: e?.value?.eventName || '',
                      eventNotes: e?.value?.eventNotes || '',
                      assignedUser: formattedAssignToUser,
                      linkedUser: formattedLinkedUser,
                      mtgLinkAddress: e?.value?.mtgLinkAddress || '',
                      firstName: e?.value?.firstName || '',
                      lastName: e?.value?.lastName || '',
                      eventStatus: e?.value?.eventStatus || '',
                      projectId: e?.value?.projectId || '',
                    });

                    setIsEdit(true);
                    setEventId(e.value._id);
                  } else {
                    setSearchedData(initSelectData);
                    setFormData(initEvent);
                  }
                }}
              />
              <i className="fa-solid fa-magnifying-glass taskSearGlass" style={{ left: "108px" }}></i>
            </div>

            {/* date */}
            <div className="taskTabInps">
              <input
                className="taskSearInp"
                type="date"
                name="date"
                value={formData.date}
                onChange={e => handleEventChange(e)}
              />
            </div>
          </div>

          <div className="taskMainInpDiv">
            {/* start time */}
            <div className="taskTabInps">
              <input
                type="time"
                className="taskDateTimeInp"
                name="startTime"
                value={formData.startTime}
                onChange={e => handleEventChange(e)}
              />
            </div>

            {/* end time */}
            <div className="taskTabInps">
              <input
                type="time"
                className="taskDateTimeInp"
                name="endTime"
                value={formData.endTime}
                onChange={e => handleEventChange(e)}
              />
            </div>
          </div>

          {/* Event Name */}
          <div className="taskMainInpDiv">
            <input
              type="text"
              placeholder={language.event_name}
              className="taskUpperInp"
              name="eventName"
              value={formData.eventName}
              onChange={e => handleEventChange(e)}
            />
          </div>

          {/* Event Notes */}
          <div className="taskMainInpDiv">
            <input
              type="text"
              placeholder={language.event_note}
              className="taskUpperInp"
              name="eventNotes"
              value={formData.eventNotes}
              onChange={e => handleEventChange(e)}
            />
          </div>

          {/* status */}
          <div className="taskMainInpDiv">
            <select
              className="taskUpperInp"
              name="eventStatus"
              value={formData.eventStatus}
              onChange={e => handleEventChange(e)}
            >
              <option value="" disabled>
                {language.event_Status_optional}
              </option>
              <option value="open">{language.open}</option>
              <option value="doing">{language.doing}</option>
              <option value="done">{language.done}</option>
              <option value="ideas">{language.ideas}</option>
              <option value="onhold">{language.on_hold}</option>
            </select>
          </div>

          {/* Assign (user) */}
          <div className="taskMainInpDiv">
            <Select
              className="taskUpperInpSearch"
              placeholder="Assign to User(Select)"
              isClearable={true}
              isSearchable={true}
              name="assignedUser"
              value={formData.assignedUser}
              options={selectAssignUserMemo}
              onChange={e => {
                setFormData(prev => ({
                  ...prev,
                  assignedUser: e || initSelectData
                }));
              }}
            />
          </div>

          {isMainUserMemo && (
            <div className="taskMainInpDiv" style={{ display: 'none' }}>
              <Select
                className="taskUpperInpSearch"
                placeholder="Assign to User(Select)"
                isClearable={true}
                isSearchable={true}
                name="assignedUser"
                value={formData.assignedUser}
                options={selectAssignUserMemo}
                onChange={e => {
                  setFormData(prev => ({
                    ...prev,
                    assignedUser: e || initSelectData
                  }));
                }}
              />
            </div>
          )}

          {/* Link Users, Customers. Vendors */}
          <div className="taskMainInpDiv">
            <Select
              className="taskUpperInpSearch"
              placeholder={language.Link_Users_Customers_Vendors}
              isClearable={true}
              isSearchable={true}
              name="linkedUser"
              value={formData.linkedUser}
              options={selectCustVendorMemo}
              onChange={e => {
                setFormData(prev => ({
                  ...prev,
                  linkedUser: e || initSelectData
                }));
              }}
            />
          </div>

          <div className="taskMainInpDiv">
            {/* first */}
            <div className="taskTabInps">
              <input
                type="text"
                className="taskUpperInp"
                placeholder={language.first}
                name="firstName"
                value={formData.firstName}
                onChange={e => handleEventChange(e)}
              />
            </div>

            {/* last */}
            <div className="taskTabInps">
              <input
                type="text"
                className="taskUpperInp"
                placeholder={language.last}
                name="lastName"
                value={formData.lastName}
                onChange={e => handleEventChange(e)}
              />
            </div>
          </div>

          <div className="taskMainInpDiv">
            {/* Mtg Link / Address / Dial Info */}
            <input
              type="text"
              className="taskUpperInp"
              placeholder={language.Mtg_Link_Info}
              name="mtgLinkAddress"
              value={formData.mtgLinkAddress}
              onChange={e => handleEventChange(e)}
            />
          </div>

          {/* Assign To Project */}
          <div className="taskMainInpDiv">
            <select
              className="taskUpperInp"
              name="projectId"
              value={formData.projectId}
              onChange={(e) => handleEventChange(e)}
            >
              <option value="" disabled>
                {language.assign_to_project}
              </option>
              {assignProjectData?.map((item, i) => (
                <option key={i} value={item?._id}>{item?.projectName}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="postTaskBtnDiv">
          {
            !isEdit ? (
              <button
                type="button"
                onClick={handleSchrdule}
              >
                {language.Schedule}
              </button>
            ) : (
              <button
                type="button"
                onClick={handleUpdate}
              >
                {language.Update}
              </button>
            )
          }
        </div>
      </form>

      <div className="orDrFigDiv">
        <p className="orDrText">{language.Or_drop_to_calendar}</p>
        <figure className="fisiDrIconFig">
          <img src={FisEventIcon} alt="..." />
        </figure>
      </div>

      {/* Quick View */}
      {eventAllData?.length !== 0 && (
        <div className="quickMainViewDiv">
          <p className="ouickViewHead">{language.Quick_View}</p>
          <div className="quickViewUlDiv">
            <ul style={{ maxHeight: "255px" }} className="quickViewUl">
              {eventAllData?.map((item, i) => (
                <li
                  key={i}
                  className="quickViewLi"
                  onClick={() => {
                    setModalb(true);
                    setTaskDetailData(item);
                  }}
                >
                  <div>
                    <p className="quickAnsText">{item?.eventName}</p>
                    <div className="quickDoneTextDiv">
                      <p className="quickDoneText quickGreenDoneDot">{item?.eventStatus}</p>
                    </div>
                  </div>
                  <div className="quickViewActions">
                    <figure className="quickFirstIconFig">
                      <img src={FisEventIcon} alt="..." />
                    </figure>
                    <button
                      className="deleteProjectBtn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteClick(item);
                      }}
                      title={language.Delete_Event}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}




      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="delete-modal-overlay">
          <div className="delete-modal-content">
            <div className="delete-modal-header">
              <h3>Delete Event</h3>
              <button
                className="delete-modal-close"
                onClick={() => {
                  setDeleteModalOpen(false);
                  setProjectToDelete(null);
                  setDeleteConfirmText('');
                }}
                disabled={deleting}
              >
                &times;
              </button>
            </div>
            <div className="delete-modal-body">
              <p>
                {language.Delete_Event_PopUp_Body1} <strong>"{projectToDelete?.eventName}"</strong>?
                {language.Delete_Event_PopUp_Body2}
              </p>
              <p>
                Type <strong>delete</strong> to confirm:
              </p>
              <input
                type="text"
                className="delete-confirm-input"
                value={deleteConfirmText}
                onChange={(e) => setDeleteConfirmText(e.target.value)}
                placeholder="Type 'delete' here"
                disabled={deleting}
              />
            </div>
            <div className="delete-modal-footer">
              <button
                className="delete-modal-cancel"
                onClick={() => {
                  setDeleteModalOpen(false);
                  setProjectToDelete(null);
                  setDeleteConfirmText('');
                }}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                className="delete-modal-confirm"
                onClick={confirmDelete}
                disabled={deleteConfirmText.toLowerCase() !== 'delete' || deleting}
              >
                {deleting ? 'Deleting...' : 'Delete Event'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EventSidebar